import assignProductSelect from "./assignProductSelect.container";

export default assignProductSelect;
